import { TextField, TextFieldProps } from "@mui/material";

type DescriptionTextFieldProps = Omit<TextFieldProps, "multiline"> & {
	maxLength?: number;
};

const DescriptionTextField = ({
	fullWidth = true,
	helperText,
	maxLength,
	maxRows,
	minRows,
	rows,
	slotProps,
	value,
	...props
}: DescriptionTextFieldProps) => {
	const characterCounter = maxLength === undefined ? undefined : `${String(value ?? "").length}/${maxLength}`;
	const defaultRows = minRows === undefined && maxRows === undefined ? 2 : undefined;
	const slotPropsWithMaxLength =
		maxLength === undefined ? slotProps : { ...slotProps, htmlInput: { maxLength, ...slotProps?.htmlInput } };
	return (
		<TextField
			fullWidth={fullWidth}
			helperText={helperText ?? characterCounter}
			maxRows={maxRows}
			minRows={minRows}
			multiline
			rows={rows ?? defaultRows}
			slotProps={slotPropsWithMaxLength}
			value={value}
			{...props}
		/>
	);
};

export default DescriptionTextField;
